import WebApi from "@/views/loyalty/shared/modules/web_api"

export class HeaderEndpointService {
    constructor (url) {
        this.url = url || `${process.env.VUE_APP_LOYALTY_URL}api/header/`
        this.webApi = new WebApi()
    }

    async read_header (entity, client) {
        return this.webApi.get(`${this.url}${entity}/${client ? client.id : "0"}`)
    }

    async create_header (headers) {
        return this.webApi.post(`${this.url}`, headers)
    }
}
